import { Button, Checkbox, Col, Row, Tooltip, Input } from 'antd';
import React, { Component } from 'react';
import { GSTPaidFlagCountries } from './../../../../services/fieldRequired';
import InputFormat from './../../../../components/input-format';
import { regexExcludeNumber } from './../../../../services/ruleValidate';
import deleteDisable from './../../../../resources/assets/images/deleteDisable.png';
import deleteEnable from './../../../../resources/assets/images/deleteEnable.png';
import dataRow from './dataRow';
import './styles.css';
import OrderHelper from './../../../../services/orderHelper';
import { orderStatus } from '../../../../constants';
import { permissions } from '../../../../constants';
import { MaxNoOfPackages } from '../../../../constants';
import { ListChannel as ListChannelConst } from '../../../../constants/setting_channel';
import handlePermission from './../../../app/handlePermission';

class ItemsComponent extends Component {
    addRowItem = () => {
        let items = [...this.props.itemOrder]
        let { information: { channel_short_name } } = this.props.order
        let data = dataRow()
        if (channel_short_name !== ListChannelConst.AMAZON_JP.ShortName) {
            data.classes.channel_order_item = '';
        }
        data.addRow = true
        items.push(data)
        this.props.onChangeItem(items)

        setTimeout(function () {
            window.scrollTo(0, document.body.scrollHeight)
        }, 50);
    }

    onChange = (value, column) => {
        let items = [...this.props.itemOrder]
        let deleteDisable = true

        items.map((item, keyRow) => {
            item[column] = value
            if (item.checked && column === 'checked') {
                deleteDisable = false
            }
            return item
        })
        if (column === 'checked') {
            this.props.onChange({ value: deleteDisable, column: 'deleteDisable' })
        }

        if (column === 'NoOfPackages') {
            if (value < 1) {
                value = 1
            }
            this.props.onChange({ value, column: 'NoOfPackages' })
        }

        this.props.checkedAllItems({ items, checked_all: value })
        this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' })
    }

    onChangeOrder = (value, column) => {
        if (column === 'NoOfPackages') {
            // Only allow positive integers (or empty string for temporary input)
            if (value === '' || value === null || value === undefined) {
                this.props.onChangeInformation({ value: '', column });
                this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' });
                return;
            }
            // Remove any non-digit characters
            const numericValue = value.toString().replace(/[^0-9]/g, '');
            if (numericValue === '') {
                // Allow empty string temporarily while user is typing
                this.props.onChangeInformation({ value: '', column });
                this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' });
                return;
            }
            // Convert to number and ensure it's a positive integer
            const intValue = parseInt(numericValue, 10);
            if (!isNaN(intValue) && intValue > 0) {
                this.props.onChangeInformation({ value: intValue, column });
                this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' });
            }
            // Set limit of NoOfPackages
            if (intValue > MaxNoOfPackages) {
                this.props.onChangeInformation({ value: MaxNoOfPackages, column });
                this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' });
            }
        } else {
            this.props.onChange({ value, column });
        }
    }

    removeMultipleItem = () => {
        let items = [...this.props.itemOrder]
        let errorOrder = this.props.order.error

        let itemNew = items.filter((item, keyRow) => {
            if (item.checked) {
                let indexItemName = errorOrder.indexOf('item_name' + item.key)
                if (indexItemName !== -1) {
                    errorOrder.splice(indexItemName, 1)
                }

                let indexOrigin = errorOrder.indexOf('origin' + item.key)
                if (indexOrigin !== -1) {
                    errorOrder.splice(indexOrigin, 1)
                }
            }
            return item.checked === false
        })

        this.props.checkedAllItems({ items: itemNew, checked_all: false })
        this.props.onChange({ value: true, column: 'deleteDisable' })
        this.props.onChange({ value: errorOrder, column: 'error' })
    }

    render() {
        let totalOrderItem = 0
        let showGSTPaid = false
        const { itemOrder, pageType, order, order: { information } } = this.props
        if (GSTPaidFlagCountries.includes(information.country)) {
            showGSTPaid = true
        }
        for (let i = 0; i < itemOrder.length; i++) {
            let price_adjusted = String(itemOrder[i]['price_adjusted']).replace(regexExcludeNumber, '')
            let qty = String(itemOrder[i]['qty']).replace(regexExcludeNumber, '')

            totalOrderItem += OrderHelper.roundNumber(price_adjusted * qty);
        }

        return (
            <div className="item-talbe item-information" id="item-information">
                <div className="warp-title">
                    <Row>
                        <h1 className='title'>ITEM INFORMATION</h1>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <div className="box-utility">
                                <div className="pull-left filter-add item-utility">
                                    {
                                        handlePermission(permissions.OrderCreateNewOrder) ?
                                            <div className="icon">
                                                <Tooltip placement="topLeft" title="Add item">
                                                    <Button className="icon-add icon-add-box-utility"
                                                        icon="plus"
                                                        size={'small'}
                                                        onClick={this.addRowItem}
                                                        disabled={order.information.save_item || information.status_id === orderStatus.SPLIT}
                                                    />
                                                </Tooltip>
                                            </div>
                                            : ''
                                    }

                                    {
                                        handlePermission(permissions.OrderUpdateOrder) ?
                                            <div className="icon">
                                                <Tooltip placement="topLeft" title="Delete item">
                                                    <Button
                                                        size={'small'}
                                                        className='delete-item-in-order'
                                                        onClick={this.removeMultipleItem}
                                                        disabled={this.props.order.deleteDisable
                                                            || order.information.save_item
                                                            || information.status_id === orderStatus.SPLIT
                                                        }
                                                    >
                                                        <img src={this.props.order.deleteDisable ? deleteDisable : deleteEnable} />
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                            : ''
                                    }
                                    <div className={handlePermission(permissions.OrderUpdateOrder) ? "order-total-value" : "order-total-value not-per-update"}>
                                        <label>Total Order Value</label>
                                        <InputFormat
                                            className="text-right"
                                            disabled
                                            value={parseFloat((totalOrderItem)).toFixed(2)}
                                            isRedstar={false}
                                            allowNegative={true}
                                        />
                                    </div>
                                    {order.shipperInformation.multiPackageFlg && order.information.FulfillmentOption == 1 ?
                                        <div className={handlePermission(permissions.OrderUpdateOrder) ? "order-total-value" : "order-total-value not-per-update"} style={{ marginLeft: '30px' }}>
                                            <label>No of Package(s)</label>
                                            <Input
                                                className="text-right"
                                                value={order.information.NoOfPackages || 1}
                                                onChange={e => this.onChangeOrder(e.target.value, 'NoOfPackages')}
                                                placeholder="Enter number"
                                            />
                                        </div> : ''
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th className='cols-checkbox'>
                                <Checkbox
                                    checked={this.props.order.checked_all_items}
                                    onChange={e => this.onChange(e.target.checked, 'checked')}
                                    disabled={order.information.save_item || information.status_id === orderStatus.SPLIT}
                                />
                            </th>
                            <th className='cols-no'>NO</th>
                            <th className='cols-sku'>SKU</th>
                            <th className='cols-item-code'>CHANNEL ITEM CODE</th>
                            <th className='cols-item-name'>ITEM NAME(EN)</th>
                            {/* <th className='cols-item-discount'>&nbsp;</th> */}
                            <th className='cols-item-value'>DECLARED VALUE</th>
                            <th className='cols-qty'>QTY</th>
                            <th className='cols-total-value'>TOTAL VALUE</th>
                            <th className='cols-origin'>ORIGIN</th>
                            <th className='cols-channel-order-item'>CHANNEL ORD. ITEM #</th>
                            {showGSTPaid ? <th className='cols-checkbox'>GST Paid</th> : ''}
                        </tr>
                    </thead>
                    <tbody>{this.renderRow()}</tbody>
                </table>
            </div>
        )
    }
}

export default ItemsComponent



// WEBPACK FOOTER //
// ./src/containers/orders/components/items/index.js